export default {
    REVIEW_CARD_HEIGHT: 472,
    REVIEW_CARD_WIDTH: 410,
    MOBILE_REVIEW_CARD_WIDTH: 300
};
